import React from "react";
import { Layout, Spin } from "antd";
import { routes} from "@/routers";
import "./index.less";
import { useRoutes} from "react-router-dom";
import {Content} from "antd/es/layout/layout";

const SchoolDiagnose: React.FC = () => {
  return <>{useRoutes(routes)}</>
};

export default SchoolDiagnose;
